import React, { useEffect, useState, useMemo } from "react";
import { formatNumberWithCommas, formatDate } from '../../../common/utility'

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button,
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

import { getdealerReport } from "../../../helpers/UAM/report.helper"

import TableContainerV1 from "components/Common/TableContainerV1";
import * as XLSX from 'xlsx';
import { formatDateTime } from "common/utility";

const DealerReport = props => {

  //meta title
  document.title = "Dealer Reports | DMS";

  const [dealerReportData, setDealerReportData] = useState([])

  const [pagination, setPagination] = useState({ pageIndex: 0, pageCount: 0, totalRecords: 0, })
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("entityName");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [sortingOptions, setSortingOptions] = useState({
    column: "", isAsc: false, optionalColumn: ['fullAddress'],
  });

  // Customber Column
  const columns = useMemo(
    () => [

      {
        Header: 'Dealer Name',
        accessor: 'entityName',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
        }
      },
      {
        Header: 'Dealer Code',
        accessor: 'entityCode',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
          ;
        }
      },
      {
        Header: 'Sales Office',
        accessor: 'salesOffice',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
        }
      },
      {
        Header: 'Region',
        accessor: 'region',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
        }
      },
      {
        Header: 'Contact No.',
        accessor: 'phone',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
        }
      },
      {
        Header: 'Email',
        accessor: 'email',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
        }
      },
      {
        Header: 'Address',
        accessor: 'fullAddress',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
        }
      },
      {
        Header: 'Total Order Purchased',
        accessor: 'totalOrderSales',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
        }
        // <div style={{ textAlign: 'right'}}>
        //     {formatNumberWithCommas(cellProps.value ? cellProps.value : "")}
        // </div>

      },
      {
        Header: 'Last Order Date',
        accessor: 'lastOrderDate',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? formatDate(cellProps.value) : "NA";
        }
      },

    ],
    []
  );

  useEffect(() => {
    fetchDealerReport({})
  }, [])

  const fetchDealerReport = (data) => {
    getdealerReport(data)
      .then((response) => {
        if (response.status && response.code == 200) {
          let resultWithFormatttedDate = response.data.data.map(item => {
            item.lastOrderDate = item.lastOrderDate ? formatDateTime(item.lastOrderDate) : "NA"
            return item
          })
          setDealerReportData(resultWithFormatttedDate);
          const { totalItems, totalPages, currentPage } = response.data
          setPagination({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          })
        } else {
          setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
          setDealerReportData([])
        }
      })
      .catch((err) => { console.log(err) })
  }

  const handlePageChange = (page, pageSize, searchKey = searchValue, columnName = columnId, sortingOrder = sortingOrderStatus) => {
    setPageSize(pageSize);
    setCurrentPage(page)
    fetchDealerReport({ page, limit: pageSize, searchKey, columnName, sortingOrder })
  };

  const handleSortColumn = (option) => {
    setSortingOptions(option);
    const columnName = option.column;
    setColumnId(columnName);
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder);
    handlePageChange(currentPage, pageSize, searchValue, columnName, sortingOrder);
  };


  const handleSearchFilter = (value, pageSize) => {
    const newValue = value !== undefined ? value : "";
    setSearchValue(newValue);
    handlePageChange(1, pageSize, newValue);
  };

  const handleClearSearch = () => {
    setSearchValue("");
    handlePageChange(1, pageSize, "");
  };

  const downloadExcel = () => {
    let dataWithModifiedCol = dealerReportData.map(report => {
      let newReport = {
        "Dealer Name": report.entityName,
        "Dealer Code": report.entityCode,
        "Sales Office": report.salesOffice,
        "Region": report.region,
        "Contact No.": report.phone,
        "Email": report.email,
        "Address": report.fullAddress,
        "Total Order Purchased": report.totalOrderSales,
        "Last Order Date": report.lastOrderDate,
      }
      return newReport
    })

    // Create a new workbook
    const workbook = XLSX.utils.book_new();
    const sheetData = XLSX.utils.json_to_sheet(dataWithModifiedCol);
    // Add the sheet to the workbook
    XLSX.utils.book_append_sheet(workbook, sheetData, 'DealerReport');
    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, 'Dealer_Report.xlsx');
  };

  const buttonSection = (
    <div className="text-sm-end">

      <Button
        type="button"
        color="success"
        className="btn-rounded mb-2 me-2"
        onClick={downloadExcel}

      >
        <i className="bx bx-archive-in me-1" />
        {'Download'}
      </Button>

    </div>);

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Reports" breadcrumbItem="Dealer Report" />
        <Row>
          <Col xs="12">
            <Card>
              <CardBody>
                <TableContainerV1
                  columns={columns}
                  data={dealerReportData}
                  pagination={pagination}
                  handlePageChange={handlePageChange}
                  handleSearchFilter={handleSearchFilter}
                  customSection={buttonSection}
                  sortOptions={sortingOptions}
                  handleSortColumn={handleSortColumn}
                  searchHelperText="Search by Dealer Name, Dealer Code"
                  handleClearSearch={handleClearSearch}
                  className="custom-header-css"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DealerReport;
